import { GetVariableConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getGetVariableTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as GetVariableConfig;
	return [
		{
			id: 'add-get-variable',
			selector: '[data-tour="add-get-variable"]',
			content: 'This button will add more mappings to the list.',
		},
		...(config.variables.length > 0
			? [
					{
						id: 'variable-name',
						selector: '[data-tour="variable-name"]',
						content:
							'Required: This is a drop down list of all the available variables in the current scope.',
					},
					{
						id: 'variable-path',
						selector: '[data-tour="variable-path"]',
						content:
							'Required: The path in the result object where the value will be saved. Currently this is a plain string path. "." is used to indicate jump into the object. i.e. "an.example.path".',
					},
					{
						id: 'example-value',
						selector: '[data-tour="example-value"]',
						content: "Displays an example of what the fetched variable's value will be.",
					},
					{
						id: 'delete-value',
						selector: '[data-tour="delete-value"]',
						content: 'The delete button will remove the specific variable mapping.',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
